import React from "react";
import CollapsiblePanel from "../base/CollapsiblePanel";
import API from "../base/API";
import { translate } from "../base/Translation";

export default class OppositionForm extends React.Component {

    constructor(props) {
        super(props);

        this.api = new API({
            get_form: "/form/fetch/:form",
            save_opposition: "/opposition/save/new",
            get_question_answers: "/answer/fetch/by/question/:question?form=:form&test=:test"
        });

        this.state = {
            answers: [],
            notes: [],
            form: false,
            form_protocol: false,
            dataFeed: false,
            selectedForm: 0,
            selectedSection: 0,
            selectedGroup: 0,
            selectedQuestion: 0,
            opposition: "",
        }
    }

    componentDidMount() {
        this.api.request({
            route: "get_form",
            params: { form: this.props.test.form.id },
            success: (response) => {
                this.setState({ form: response });
            }
        });
    }

    onSave() {
        const opposition = {
            text: this.state.opposition,
            question: this.state.selectedQuestion,
            form: this.state.dataFeed.id,
            test: this.props.test.id
        };

        this.api.request({
            route: "save_opposition",
            data: opposition,
            created: (response) => {
                alert(translate("Námietka bola úspešne uložená ako koncept."));
                this.setState({
                    opposition: "",
                    selectedSection: 0,
                    selectedGroup: 0,
                    selectedQuestion: 0,
                    notes: [],
                    answers: []
                });
                this.props.reload();
                window.dispatchEvent(new Event("reloadLog"));
            }
        })
    }

    onFormSelect(evt) {
        const form = evt.target.value === "form" ? this.state.form : this.state.form_protocol;

        this.setState({
            selectedForm: parseInt(evt.target.value, 10),
            selectedSection: 0,
            selectedGroup: 0,
            selectedQuestion: 0,
            dataFeed: form
        });
    }

    onSectionSelect(evt) {
        this.setState({
            selectedSection: parseInt(evt.target.value, 10),
            selectedGroup: 0,
            selectedQuestion: 0,
        });
    }

    onGroupSelect(evt) {
        this.setState({
            selectedGroup: parseInt(evt.target.value, 10),
            selectedQuestion: 0,
        });
    }

    async onQuestionSelect(evt) {

        this.api.request({
            route: "get_question_answers",
            params: { question: parseInt(evt.target.value, 10), form: this.state.dataFeed.id, test: this.props.test.id },
            success: (response) => {
                this.setState({
                    answers: response.answers,
                    notes: response.notes
                });
            }
        });

        this.setState({
            selectedQuestion: parseInt(evt.target.value, 10)
        });
    }

    renderFormSelect() {
        return (
            <div className="form-group" >
                <label className="control-label">{translate("Vyberte dotazník")}</label>
                <select className="form-control" onChange={this.onFormSelect.bind(this)}>
                    <option value={0}>{translate("Vyberte")}</option>
                    <option value="form">{this.state.form.name}</option>
                    <option value="protocol">{this.state.form_protocol.name}</option>
                </select>
            </div>
        )
    }

    renderSectionSelect() {
        if (this.state.selectedForm === 0) {
            return false;
        }

        return (
            <div className="form-group">
                <label className="control-label">{translate("Vyberte sekciu")}</label>
                <select className="form-control" value={this.state.selectedSection} onChange={this.onSectionSelect.bind(this)}>
                    <option value={0}>{translate("Vyberte")}</option>
                    {this.state.dataFeed.question_sections.map((item, index) => {
                        return <option key={index} value={item.id}>{item.name}</option>
                    })}
                </select>
            </div>
        )
    }

    renderGroupSelect() {
        if (this.state.selectedSection === 0) {
            return false;
        }

        const section = this.state.dataFeed.question_sections.find((section) => {
            return section.id === parseInt(this.state.selectedSection, 10)
        });

        return (
            <div className="form-group">
                <label className="control-label">{translate("Vyberte skupinu")}</label>
                <select className="form-control" value={this.state.selectedGroup} onChange={this.onGroupSelect.bind(this)}>
                    <option value={0}>{translate("Vyberte")}</option>
                    {section.question_groups.map((item, index) => {
                        return <option key={index} value={item.id}>{item.name}</option>
                    })}
                </select>
            </div>
        )
    }

    renderQuestionSelect() {
        if (this.state.selectedGroup === 0) {
            return <div />;
        }

        const section = this.state.dataFeed.question_sections.find((section) => {
            return section.id === parseInt(this.state.selectedSection, 10)
        });

        const group = section.question_groups.find((group) => {
            return group.id === parseInt(this.state.selectedGroup, 10)
        });

        return (
            <div className="form-group">
                <label className="control-label">{translate("Vyberte Otázku")}</label>
                <select className="form-control" value={this.state.selectedQuestion} onChange={this.onQuestionSelect.bind(this)}>
                    <option value={0}>{translate("Vyberte")}</option>
                    {group.questions.map((item, index) => {
                        return <option key={index} value={item.id}>{item.name}</option>
                    })}
                </select>
            </div>
        )
    }

    renderRestOfTheForm() {
        if (this.state.selectedQuestion === 0) {
            return <div />
        }

        let answer = false;

        if (typeof this.state.answers[this.state.dataFeed.id] !== "undefined" && typeof this.state.answers[this.state.dataFeed.id][this.state.selectedQuestion] !== "undefined") {
            try {
                answer = this.state.answers[this.state.dataFeed.id][this.state.selectedQuestion].map((text, index) => {
                    return <li key={index}>{text}</li>;
                });
            } catch (e) {
                answer = <li>{this.state.answers[this.state.dataFeed.id][this.state.selectedQuestion]}</li>;
            }
        }

        return (
            <div>
                <div className="form-group">
                    <label className="control-label">{translate("Odpoveď/e k tejto otázke:")} </label>
                    {answer !== false ? <ul>{answer}</ul> : <p>{translate("Žiadne odpovede neboli nájdené.")}</p>}
                </div>
                <div className="form-group">
                    <label className="control-label">{translate("Poznámka k tejto otázke:")} </label>
                    {this.state.notes.length > 0 ? <p>{this.state.notes[0].text}</p> : <p>{translate("Žiadna poznámka nebola nájdená.")}</p>}
                </div>
                <div className="form-group">
                    <label className="control-label">{translate("Vaša námietka")}</label>
                    <textarea className="form-control" onChange={(evt) => {
                        this.setState({ opposition: evt.target.value });
                    }} />
                </div>
                <div className="form-group">
                    <button className="btn btn-success" onClick={this.onSave.bind(this)}>
                        <i className="fa fa-save" />&nbsp; {translate("Uložiť")}
                    </button>
                </div>
            </div>
        )
    }

    render() {

        if (this.state.form === false) {
            return <div />
        }

        return (
            <div>
                <CollapsiblePanel title={translate("Nová námietka")} expanded={true}>
                    {this.renderFormSelect()}
                    {this.renderSectionSelect()}
                    {this.renderGroupSelect()}
                    {this.renderQuestionSelect()}
                    {this.renderRestOfTheForm()}
                </CollapsiblePanel>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/opposition/OppositionForm.jsx